import { create } from "zustand"

type VuplexStore = {
  pushNotificationsEnabled: boolean | undefined
}

export const useVuplexStore = create<VuplexStore>(() => ({
  pushNotificationsEnabled: undefined,
}))
